import { FC, FocusEvent, useState } from 'react';

import SvgChevronDown from '@/assets/icons/ChevronDown';
import SvgChevronUp from '@/assets/icons/ChevronUp';

import usePlankTableStore from '../../hooks/usePlankTableStore';
import { PlankViews } from '../../state/types/PlankTableStore';

import styles from './PlankViewSwitcher.module.css';

const OPTIONS: { view: PlankViews; label: string }[] = [
  { view: 'materieel', label: 'Landelijk' },
  { view: 'knoop', label: 'Regionaal' },
];

const PlankViewSwitcher: FC = () => {
  const tableView = usePlankTableStore((state) => state.tableView);
  const setTableView = usePlankTableStore((state) => state.setTableView);
  const [open, setOpen] = useState(false);

  const selectedOption = OPTIONS.find((option) => option.view === tableView) ?? OPTIONS[0];

  return (
    <div
      className={styles.plankViewSwitcherStyle}
      tabIndex={0}
      onBlur={(event: FocusEvent<HTMLDivElement>) => {
        if (!event.currentTarget.contains(event.relatedTarget)) {
          setOpen(false);
        }
      }}
    >
      <button
        type='button'
        className={styles.plankViewSwitcherButtonStyle}
        onClick={() => setOpen((current) => !current)}
        aria-expanded={open}
        aria-haspopup='listbox'
      >
        <span>{selectedOption.label}</span>
        {open ? (
          <SvgChevronUp aria-hidden='true' width={16} height={16} />
        ) : (
          <SvgChevronDown aria-hidden='true' width={16} height={16} />
        )}
      </button>
      {open && (
        <ul className={styles.plankViewSwitcherMenuStyle} role='listbox'>
          {OPTIONS.map((option) => (
            <li key={option.view}>
              <button
                type='button'
                role='option'
                aria-selected={option.view === tableView}
                className={[styles.plankViewSwitcherOptionStyle, option.view === tableView ? styles.selected : ''].join(
                  ' ',
                )}
                onClick={() => {
                  setTableView(option.view);
                  setOpen(false);
                }}
              >
                {option.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
export default PlankViewSwitcher;
